module.exports = __webpack_public_path__ + "img/font_download.50ef2240.svg";